import { render, staticRenderFns } from "./component.vue?vue&type=template&id=42fdc606&scoped=true"
import script from "./component.vue?vue&type=script&lang=js"
export * from "./component.vue?vue&type=script&lang=js"
import style0 from "./component.vue?vue&type=style&index=0&id=42fdc606&prod&lang=stylus"
import style1 from "./component.vue?vue&type=style&index=1&id=42fdc606&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fdc606",
  null
  
)

export default component.exports